import * as React from 'react'

import { Skeleton } from '~ui/components/loadingSkeletons/Skeleton'
import { Number } from '~ui/components/typography/Number/Number'
import { Text } from '~ui/components/typography/Text/Text'

import { useProductDetailCtx } from '../contexts/ProductDetailProvider'
import {
  useProductDetailDataCtx,
  useProductDetailStateCtx,
} from '../contexts/ProductDetailStateProvider'

type TProps = NoChildren

/**
 * Total sum of the product & selected addons rendered in ProductDetail,
 */
export const ProductDetailTotal: React.FC<TProps> = () => {
  const { isLoading } = useProductDetailDataCtx()
  const { editedCartItemIds } = useProductDetailCtx()
  const { productPriceSum } = useProductDetailStateCtx()

  const isCartItem = editedCartItemIds !== null

  return (
    <Skeleton showSkeleton={isLoading} alignSelf={`stretch`}>
      <Text textAlign={isCartItem ? `left` : `right`} fontStyle={`bold`} fontSize={`l24`}>
        {isLoading ? `placeholder sum` : <Number>{productPriceSum}</Number>}
      </Text>
    </Skeleton>
  )
}
